import { render, staticRenderFns } from "./CartProductDetailsSidebar.vue?vue&type=template&id=25c4a8d0&scoped=true"
import script from "./CartProductDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./CartProductDetailsSidebar.vue?vue&type=script&lang=js"
import style0 from "./CartProductDetailsSidebar.vue?vue&type=style&index=0&id=25c4a8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c4a8d0",
  null
  
)

export default component.exports